<emi-historial-cae-filter (dataFilter)="onSearch($event)"></emi-historial-cae-filter>
<div class="container-fluid">
    <!-- LISTADO -->
    <div class="row px-3 mb-5 mt-4">
        <div class="content-wrap">
            <table class="table table-custom table-hover table-sm table-grid-responsive">
                <caption></caption>
                <thead class="th-custom">
                    <tr>
                        <th class="th-grid-responsive">{{ 'record-cae-user.gridColumns.CreationDateInit' | translate }}
                        </th>
                        <th class="th-grid-responsive">{{ 'record-cae-user.gridColumns.CreationDateEnd' | translate }}
                        </th>
                        <th class="th-grid-responsive">{{ 'record-cae-user.gridColumns.SuccessfulRecords' | translate }}
                        </th>
                        <th class="th-grid-responsive">{{ 'record-cae-user.gridColumns.FailedRecords' | translate }}
                        </th>
                        <th class="th-grid-responsive">{{ 'record-cae-user.gridColumns.Status' | translate }}
                        </th>
                        <th class="text-center w-160-px"></th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngFor="let data of dataInformation">
                        <tr class="tr-custom">
                            <td class="td-grid-responsive text-left">
                                <span class="th-name-col">{{ 'record-cae-user.gridColumns.DateInit' | translate
                                    }}</span>
                                <span class="td-value-row mr-3 ml-3"> {{ data.startTime | date:'dd-MM-yyyy' }}
                                </span>
                                <br>
                                <span class="td-value-row mr-3 ml-3"> {{ data.startTime | date:'hh:mm:ss' }}
                                </span>
                            </td>

                            <td class="td-grid-responsive text-left">
                                <span class="th-name-col">{{ 'record-cae-user.gridColumns.DateEnd' | translate
                                    }}</span>
                                <span class="td-value-row ml-3"> {{ data.endTime | date:'dd-MM-yyyy'}} </span>
                                <br>
                                <span class="td-value-row ml-3"> {{ data.endTime | date:'hh:mm:ss'}} </span>
                            </td>

                            <td class="td-grid-responsive">
                                <span class="th-name-col">{{ 'record-cae-user.gridColumns.SuccessfulRecords' | translate
                                    }}</span>
                                <span class="td-value-row"> {{ data.successful }} </span>
                            </td>
                            <td class="td-grid-responsive">
                                <span class="th-name-col">{{ 'record-cae-user.gridColumns.FailedRecords' | translate
                                    }}</span>
                                <span class="td-value-row"> {{ data.unsuccessfulRecords }} </span>
                            </td>

                            <td class="td-grid-responsive text-left">
                                <div class="ml-3" *ngIf="data.unsuccessfulRecords == 0">
                                    <i class="fa-solid fa-circle status-ok mr-3"></i>
                                    <span class="td-value-row">{{ 'record-cae-user.gridColumns.Status_ok' | translate
                                        }}</span>
                                </div>
                                <div class="ml-3" *ngIf="data.unsuccessfulRecords != 0 && data.successful != 0">
                                    <i class="fa-solid fa-circle status-warning mr-3"></i>
                                    <span class="td-value-row">{{ 'record-cae-user.gridColumns.Status_warning' |
                                        translate
                                        }}</span>
                                </div>
                                <div class="ml-3" *ngIf=" data.unsuccessfulRecords != 0 && data.successful == 0">
                                    <i class="fa-solid fa-circle status-error mr-3"></i>
                                    <span class="td-value-row">{{ 'record-cae-user.gridColumns.Status_error' | translate
                                        }}</span>
                                </div>
                            </td>

                            <td class="text-center td-content-btn td-grid-responsive ">
                                <button matTooltip="{{ 'record-cae-user.gridColumns.DownloadDetails' | translate }}"
                                    *ngIf="data.unsuccessfulRecords > 0" type="button" class="btn-none"
                                    (click)="onDownload(data.jobId)">
                                    <i class="fa-solid fa-download"></i>
                                </button>
                            </td>
                        </tr>
                    </ng-container>
                    <tr *ngIf="this.emptyDataList && this.IsPostBack" class="grid-empty text-center bg-light">
                        <td colspan="12" class="mt-3 h-360-px justify-all-center">
                            <img class="img-folder-empty" src="assets/images/icon/Folder.svg" alt="empty folder">
                            <br>
                            <span class="text-info-gray fw-w-bold">{{ msgDataEmpty }}</span>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="row mt-1 mr-4">
                <div class="col-md-12 mb-5 d-flex justify-content-end">
                    <app-pagination-table [totalPages]="totalPages" [currentPage]="currentPage"
                        (changePage)="changePage($event)"></app-pagination-table>
                </div>
            </div>
        </div>
    </div>
</div>